import { dispatchNavigateToChat } from './chatNavigation';

export const requestNotificationPermission = () => {
  if ('Notification' in window && Notification.permission === 'default') {
    Notification.requestPermission();
  }
};

export const showBrowserNotification = (title, body, chatId) => {
  if (!('Notification' in window) || Notification.permission !== 'granted') {
    return;
  }

  try {
    const notification = new Notification(title, {
      body,
      icon: '/favicon.ico',
      tag: chatId != null ? String(chatId) : undefined,
    });

    setTimeout(() => notification.close(), 5000);

    notification.onclick = () => {
      window.focus();
      if (chatId) {
        dispatchNavigateToChat(chatId);
      } else {
        dispatchNavigateToChat(null);
      }
      notification.close();
    };
  } catch (_) {
    // Browser may block notifications in unsupported contexts
  }
};
